<template>
  <div id="examroom">
    <!-- 考点管理 -->
    <small class="color-gray">工作任务数据需要在考务系统PC端处理</small>
  </div>
</template>

<script>
export default {
  name: "examroom"
};
</script>

<style scoped>
</style>